// extracted by mini-css-extract-plugin
export default {"button":"CreateNewSelectLabel_button__-hVQ2"};